import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PlaceImprintPage } from './place-imprint.page';

const routes: Routes = [
    {
        path: '',
        component: PlaceImprintPage,
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class PlaceImprintPageRoutingModule {}
